<!--
 * @Author: 广告占位图
 * @Date: 2020-07-27 12:00:41
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-27 14:21:34
 * @FilePath: \car-demo\src\components\Advertise.vue
-->
<template>
  <a class="advertse" v-on="$attrs" @click="clickAd" v-if="item && item.ad_code">
    <img :src="item.ad_code" :alt="item.ad_name"/>
  </a>
</template>

<script>
export default {
  name: 'advetise',
  // 正常传入 a 标签的属性 即可
  props: {
    item:Object,
    imgSrc: String, // 活动图片
    alt: {type: String, required: false}, // 活动名称
    height: {type: [String, Number], required: false},
  },
  methods:{
    clickAd(){
      let item = this.item;

      //无链接,点击直接返回
      if (item.link_type === 'no_link') return;

      if (item.link_type === 'web_app') {
        window.location.href = item.ad_link;
        return;
      }

      //app 直接跳转到内页
      if (item.link_type === 'app') {
          if(item.ad_key.indexOf("maintain") != -1){
            var host = window.location.host;
            window.location.href = 'http://'+host+'/'+item.ad_key+'/#/';
          }else if(item.ad_key.indexOf("businessList") != -1){
            var host = window.location.host;
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
          }else{
            let query = {
              activity_id: this.$ajax.get_activity_id(),
              id: item.ad_link
            };

            this.$router.push({name: item.ad_key, query: query})
          }
        
      }
    }
  }
}
</script>

<style lang="less" scoped>
.advertse {
  display: block;

  margin-top: 11px;
  margin-bottom: 11px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
